import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { ReactNode } from 'react';
import { Typography } from '@sweep-io/sweep-design';
import { ExpandButtonSimple } from '../../../../common/ExpandButtonSimple';
import { SectionBox } from '../../../salesforce-documentation-card/helpers';
import { useSearchContext } from '../search/SearchContext';
import { HighlightedSection } from '../search/highlight/HighlightedSection';
import { useSectionExpansion } from '../search/useSectionExpansion';
import { SectionExpansionState } from '../search/SearchContext';

interface DetailsSectionShellProps {
  title: string;
  sectionKey: keyof SectionExpansionState;
  isExpandedByDefault?: boolean;
  isEmpty?: boolean;
  children: ReactNode;
}

export const DetailsSectionShell = ({
  title,
  sectionKey,
  isExpandedByDefault,
  isEmpty,
  children,
}: DetailsSectionShellProps) => {
  const { searchTerm, sectionExpansion } = useSearchContext();

  const { isExpanded, setIsExpanded } = useSectionExpansion({
    searchTerm,
    sectionExpanded: sectionExpansion[sectionKey],
    defaultExpanded: !!isExpandedByDefault,
  });

  if (isEmpty) {
    return null;
  }

  return (
    <SectionBox data-section={sectionKey}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        onClick={() => setIsExpanded(!isExpanded)}
        sx={{ cursor: 'pointer' }}
      >
        <Typography variant="h5-medium">{title}</Typography>
        <ExpandButtonSimple buttonSize="tiny" isExpanded={isExpanded} />
      </Box>

      <Collapse in={isExpanded}>
        <HighlightedSection section={sectionKey}>{children}</HighlightedSection>
      </Collapse>
    </SectionBox>
  );
};
